import ImagesFactory from '../factory/images';

const parseThumbnails = (data) => {
  // const isYoutube = !data.file && !!data.source;
  const original = INKIVE.Helpers.getCORSSecureUrl(data.selected_thumbnail || '');

  const version = {
    ...data,
    tab: ImagesFactory.getVersionUrl(original, 'tab'),
    web: ImagesFactory.getVersionUrl(original, 'web'),
    thumb: ImagesFactory.getVersionUrl(original, 'thumb'),
    mobile: ImagesFactory.getVersionUrl(original, 'mobile'),
    largeweb: ImagesFactory.getVersionUrl(original, 'largeweb'),
    original
  };

  ImagesFactory.setImagesData({ version }, 'library', ImagesFactory.defaultAmazonDataNames);

  return version;
};

export default parseThumbnails;
